const Constants = {
	appStateKey: "com.unifiservice.apps.pulse:state",
	postSignInRedirectUrl: "com.unifiservice.apps.pulse:postSignInRedirectUrl"
};

export default Constants;